import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import { t } from 'services/translation';
import GuestsMultiSelectDropdown from 'views/ui/form_elements/multi_select_dropdown/guests';
import GuestsDropdown from 'views/ui/form_elements/dropdown/guests';

import { Theme } from 'ui_system/theme';

const GuestsLabel = styled.div`
  font-size: 19px;
  color: ${Theme.colors.black};
`;

class Guests extends React.PureComponent {
  static displayName = 'BookingRequest-Guests';

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.array,
    errors: PropTypes.array,
    disabled: PropTypes.bool,
    values: PropTypes.object,
    unitTypes: PropTypes.object,
    unitPrices: PropTypes.object,
    capacityError: PropTypes.string,
    slotTicketCapacities: PropTypes.array,
    timeSelected: PropTypes.bool,
    tourTicketCapacities: PropTypes.array,
    hasTicketCapacityEnabled: PropTypes.bool,
    capacityErrorJobInProgress: PropTypes.string,
  };

  static defaultProps = {
    value: [[]],
    errors: [],
    disabled: false,
  };

  _guestsDropdownProps = () => {
    const {
      name,
      minPeople,
      maxPeople,
      initialTicketQuantity,
      hasTicketCapacityEnabled,
      value,
      unitTypes,
      slotTicketCapacities,
      timeSelected,
      tourTicketCapacities,
    } = this.props;
    const unitType = unitTypes.items[0];
    return {
      name: name,
      min: minPeople,
      max: maxPeople,
      initialTicketQuantity: initialTicketQuantity,
      hasTicketCapacityEnabled: hasTicketCapacityEnabled,
      value: value[0].count,
      onChange: (newValue, count) => {
        this.props.onChange('units', [{ id: unitType.id, count }]);
      },
      icon: <i className="icon af-triangle-down-2" />,
      optionsLabel: t(unitType.noun_singular),
      optionsLabelPlural: t(unitType.noun_plural),
      theme: 'booking-request',
      disabled: this.props.disabled,
      ariaLabelledBy: 'guest-selection',
      slotTicketCapacities,
      timeSelected,
      tourTicketCapacities,
    };
  };

  _guestsMultiSelectDropdownProps = () => {
    const {
      unitPrices,
      unitTypes,
      is_affiliate,
      minPeople,
      maxPeople,
      onChange,
      renderToolTip,
      disabled,
      initialTicketQuantity,
      capacityError,
      hasTicketCapacityEnabled,
      slotTicketCapacities,
      timeSelected,
      tourTicketCapacities,
      capacityErrorJobInProgress,
    } = this.props;
    let { value } = this.props;
    if (value.length === 1 && value[0].count === 1 && unitPrices.items) {
      let unit = unitPrices.items.find((element) => element.id === value[0].id);
      if (!unit) {
        [unit] = unitPrices.items;
      }
      if (unit.internal_only === true) {
        value = [];
      }
    }
    if (value.length === 0 && unitTypes && unitPrices.items) {
      let unit;
      if (is_affiliate) {
        [unit] = unitPrices.items;
      } else {
        unit = unitPrices.items.find(
          (element) => element.internal_only !== true
        );
      }
      const newValues = unitPrices.items.map((item) => {
        return { id: item.id, count: item.id === unit.id ? 1 : 0 };
      });
      // previous code was filtering out internal_only unit_types in the dropdown, but did not adjust the slice of state sent to backend for the
      // booking request.  If the user did not adjust unit types, then incorrect units are sent back, resulting in incorrect pricing in guest checkout.
      // We should consider teaching the experience details page how to load without internal_only unit_types, without affecting Add a Booking or FD
      onChange('units', newValues);
      value = [{ count: 1, id: unit.id }];
    }
    return {
      min: minPeople,
      max: maxPeople,
      initialTicketQuantity: initialTicketQuantity,
      hasTicketCapacityEnabled: hasTicketCapacityEnabled,
      value,
      unitTypes,
      unitPrices,
      onChange: (newValue) => {
        onChange('units', newValue);
      },
      renderToolTip,
      for_guest: !is_affiliate,
      disabled,
      capacityError,
      slotTicketCapacities,
      timeSelected,
      tourTicketCapacities,
      capacityErrorJobInProgress,
    };
  };

  render() {
    const { unitTypes, maxPeople, minPeople } = this.props;

    let view = null;
    if (unitTypes.items.length > 1) {
      view = (
        <GuestsMultiSelectDropdown
          {...this._guestsMultiSelectDropdownProps()}
        />
      );
    } else if (maxPeople === 1 || maxPeople === minPeople) {
      const unitType = this.props.unitTypes.items[0];
      const unitTypeName =
        maxPeople === 1 ? unitType.noun_singular : unitType.noun_plural;
      view = (
        <GuestsLabel>
          {maxPeople} {unitTypeName}
        </GuestsLabel>
      );
    } else {
      view = <GuestsDropdown {...this._guestsDropdownProps()} />;
    }

    return (
      <div className="field" data-testid="guest-dropdown" id="guest-selection">
        <label aria-label="Select guest for this experience.">
          {t('FOR_ALT')}
        </label>
        {view}
      </div>
    );
  }
}

export default Guests;
